import * as React from 'react';
import { Edit, SimpleForm, TextInput, required, ImageInput } from 'react-admin';

const UploadedImages = ({ record }) => {
  if (typeof record === 'string') {
    return (
      <img src={record} alt="img" style={{ width: '300px', padding: '1em' }} />
    );
  } else {
    return (
      <img
        src={record.undefined}
        alt="img"
        style={{ width: '300px', padding: '1em' }}
      />
    );
  }
};

export const AdsEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <ImageInput
          source="image"
          label="Ads picture"
          accept="image/*"
          multiple={false}
          placeholder={<p>Drop your images here</p>}
        >
          <UploadedImages />
        </ImageInput>
        <TextInput disabled source="id" validate={[required()]} />
        <TextInput
          source="name"
          label="Business Name"
          validate={[required()]}
        />
        <TextInput source="description" validate={[required()]} />
        <TextInput source="url" validate={[required()]} />
        <TextInput disabled source="viewed" validate={[required()]} />
        <TextInput disabled source="clicked" validate={[required()]} />
      </SimpleForm>
    </Edit>
  );
};
